//接口配置
const prefix= process.env.NODE_ENV !=='development' ? '' : '/dev'

export default {
	quoteCommon: prefix+ "/quote-common", //計價頁面
	ajaxregion: prefix+ "/ajax/region", // 获取国家数据
	ajaxexpress: prefix+ "/ajax/express", //獲取物流數據
	ajaxvaluation: prefix+ "/ajax/valuation", //計價接口
	orderAddcart: prefix+ "/order/addcart", //加入購物車
	historyOrderInfo: prefix+ "/ajax/historyOrderInfo", //歷史訂單詳情
	historyOrderList: prefix+ "/ajax/historyOrderList", //歷史訂單列表
	isLogin: prefix+ "/member/login/isLogin", //是否登錄
	dologin: window.LOGINURL + "/auth/login", //登錄
	logout: window.LOGINURL + "/auth/clearToken", //登出
	addToCart: prefix+ "/order/addcart",
	verifyCode: window.LOGINURL + "/auth/code",
	feedbackAdd: prefix+ "/feedback/add",
	changeLanguage: prefix+ "/ajax/language",
	upfile: prefix+ "/upfile",
	saleQuoteAdd: prefix+ "/saleQuote/add",
	ajaxgetlang: prefix+ "/ajax/getlang",
	ajaxrecodeNonMember: prefix+ "/ajax/recodeNonMember",	
	ajaxadInfo: prefix+ "/ajax/adInfo",//獲取廣告信息
	fileAnalysisData: prefix+ "/ajax/fileAnalysisData",
	//homeAjaxcommonInfo: prefix+ "home/Ajax/commonInfo"
	getPcbList: prefix+ "/member/ajax/getPcbList", // 获取pcb单独订单
	getBomList: prefix+ "/member/ajax/getBomList", // 获取单独bom订单
	quoteAjaxGetDfmQuote: prefix+ "/quote/ajaxGetDfmQuote", //通过quoteid 获取参数
	getRegionByIp: prefix+ "/ajax/visitRegionId", //获取客户访问ip对应地区ID
	bombomMatch: prefix+ "/bom/bomMatch",
	bomNeedQuotation: prefix+ "/bom/needQuotation",
	bomDownMismatch: prefix+ "/bom/downMismatch", // bom解析错误为440055，可以下载纠错文件 返回值 mismatch_total 大于6 可以调用接口下载
	saveGuide: prefix + "/recordOperatingInstructions", // 保存新手引导是否触发
  uploadDfmFile:prefix + '/dfmView/uploadDfmFile', 	// 获取文件解析ID
  analyseResult: prefix + '/dfmView/getSwg',   // 获取文件解析svg
  orderParams: prefix + '/dfmView/getParseContent',  // 获取文件解析后的下单参数
	getPcbDelayInfo: prefix + '/ajax/pcbOrderDelayInfo',  // 获取pcb延期说明数据
	getCouponData: prefix + '/member/finance/ajax_coupon_tips',  // 获取单条最大优惠优惠券
	getOrderChange: prefix + '/order/dochange', // 获取订单修改的信息
	cancelOrderChange: prefix + '/order/cancelChange', // 取消订单修改
	getHighPlateTypes: prefix + '/ajax/getHighPlateTypes', // 获取高端板材类型详细
}